<template>
  <div class="i-unavailable-card">
    <div class="wrap">
      <div class="ctnr">
        <div class="card">
          <div class="image">
            <img
              :src="props.iconUrl"
              alt=""
            />
          </div>
          <div class="title">{{ props.title }}</div>
          <div class="text">{{ props.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  iconUrl: {
    type: String,
    default: "https://uploads-ssl.webflow.com/63b58013b3cc40c26785e355/63b58014b3cc40c35b85e39e_clumsy%201.svg"
  },
  text: {
    type: String,
    default: "Unavailable card text"
  },
  title: {
    type: String,
    default: "Unavailable card title"
  }
})
</script>

<style scoped lang="scss">
.i-unavailable-card {
  .wrap {
    margin-top: 32px;

    .ctnr {
      display: flex;
      width: 90%;
      max-width: 1160px;
      margin-right: auto;
      margin-left: auto;
      flex-direction: column;
      justify-content: center;

      .card {
        text-align: center;

        @include card($shadow: true);

        .image img {
          width: 80px;
          height: 80px;
        }

        .text {
          margin-bottom: 16px;
        }

        .title {
          margin-top: 8px;
          margin-bottom: 16px;

          @include display-sm;

          font-weight: bold;
        }

        .subtitle {
          @include text-lg;
        }
      }
    }
  }
}

@media screen and (min-width: $breakpoint-md) {
  .i-unavailable-card {
    .wrap {
      .ctnr {
        .card {
          .image img {
            width: 128px;
            height: 128px;
          }
        }
      }
    }
  }
}
</style>
